import { NativeModules } from 'react-native';
import Constants from 'expo-constants';

// Match macOS About/Sparkle using the running binary, even when the JS config
// belongs to another build. The config fallback supports older native bridges.
export function getMacAppVersion() {
  const bridge = NativeModules.MacMenuBridge;
  const version = bridge?.appVersion || Constants.expoConfig?.version;
  const build = bridge?.appVersion ? bridge.appBuild : null;
  return version ? `${version}${build ? ` (${build})` : ''}` : 'Unavailable';
}
